import { WidgetSchema } from 'features/views/LayoutEditor/types'

import { CustomCodeWidget } from './CustomCodeWidget'
import { CustomCodeWidgetAdminControls } from './CustomCodeWidgetAdminControls'
import { CustomCodeWidgetType } from './types'

export const CustomCodeWidgetMeta: WidgetSchema<CustomCodeWidgetType> = {
    category: 'hidden',
    label: 'Custom code',
    icon: 'Code',
    component: CustomCodeWidget,
    adminControlsComponent: CustomCodeWidgetAdminControls,
    defaultAttrs: {
        source: {
            type: 'inline',
            text: '',
        },
    },
    requireFields: (attrs) => {
        if (attrs.source.type === 'field') {
            return [attrs.source.fieldApiName]
        }

        return []
    },
}
